var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Countdown',{attrs:{"date":new Date('2022-01-28T16:15:00+0000'),"beauty":_vm.beauty}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }